import { AdvancedSearchFilterType } from "~/providers/AdvancedSearchProvider";
import { FilterOption, FilterType, ResCompanyData, ResIndustryData } from "~/types/filters.types";

const convertFiltersForAnalytics = (
    filters: AdvancedSearchFilterType[],
    keyword: string | undefined
) => {
    const filterVals = filters.map(f => f.value);
    if (keyword) filterVals.push("keyword: " + keyword);

    return filterVals.join(", ");
};

const convertYearDataToFilterObject = (year: string) => {
    return {
        id: Number(year),
        label: year,
        type: FilterType.YEAR
    } as FilterOption;
};

const convertIndustryDataToFilterObject = (industry: ResIndustryData) => {
    return {
        id: industry.IndustryID,
        label: {
            en: industry.Name,
            fr: industry.FrName
        },
        type: FilterType.INDUSTRY
    } as FilterOption;
};

const convertCompanyDataToFilterObject = (company: ResCompanyData) => {
    return {
        id: company.CompanyId,
        label: company.Name,
        type: FilterType.COMPANY
    } as FilterOption;
};

export {
    convertFiltersForAnalytics,
    convertYearDataToFilterObject,
    convertIndustryDataToFilterObject,
    convertCompanyDataToFilterObject
};
